import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCardsToRender,
  closeCard,
  ROADSIDE_ASSISTANCE_CARD,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import {
  trackRSAActionButtonClickOn,
  trackRSAActionButtonClickOff,
} from '../../../../gainsightTrackings/roadsideAssistanceTrackings';
import useHasAccessToRoadsideAssistance from '../../../../hooks/useHasAccessToRoadsideAssistance';

const useOutboundSMSHelpers = () => {
  const dispatch = useDispatch();

  const isRoadsideAssistanceEnabled = useHasAccessToRoadsideAssistance();

  const isRoadsideAssistanceCardOpened = useSelector(
    state => state.mapCard.cards[ROADSIDE_ASSISTANCE_CARD],
  );

  const handleRoadsideAssistanceClick = useCallback(() => {
    if (isRoadsideAssistanceCardOpened) {
      dispatch(closeCard(ROADSIDE_ASSISTANCE_CARD));
      trackRSAActionButtonClickOff();
    } else {
      dispatch(setCardsToRender(ROADSIDE_ASSISTANCE_CARD));
      trackRSAActionButtonClickOn();
    }
    // do the tracking here for roadside_assistance
  }, [isRoadsideAssistanceCardOpened, dispatch]);

  return {
    handleRoadsideAssistanceClick,
    isRoadsideAssistanceEnabled,
    isRoadsideAssistanceCardOpened,
  };
};

export default useOutboundSMSHelpers;
